import { createSelector } from 'reselect';

const modelSelector = (state) => state.api.models;

export const getModel = createSelector(modelSelector, (data) => {
  return data;
});
